import { Environment } from './environments.types';

export const environment: Environment = {
    environment: 'development',
    apiUrl: 'https://api.docentes.dev.fabrica.inf.ufg.br',
};
